import { Camera, MapPin, MessageCircle, Sparkles, CheckCheck, CheckCircle2, ScanSearch } from "lucide-react";
import { Reveal, SectionTag, SectionTitle, Bullet } from "./Reveal";

const STEPS = ["Portas", "Vedação", "Temperatura", "Evaporadores", "Organização", "Foto final"];

export function ChecklistMockup() {
  return (
    <div className="relative" data-testid="checklist-mockup">
      <div className="rounded-2xl border border-stone-200 bg-white shadow-xl overflow-hidden">
        <div className="px-5 py-4 border-b border-stone-200 flex items-center justify-between gap-3 bg-stone-50">
          <div className="min-w-0">
            <div className="text-[10px] font-bold uppercase tracking-wider text-stone-500 font-body">Checklist #204</div>
            <div className="font-display font-bold text-stone-950 truncate">Abertura · Câmara de Congelados</div>
          </div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-800 text-[11px] font-bold px-2.5 py-1 font-body whitespace-nowrap">
            <MapPin className="h-3 w-3" /> GPS verificado · raio 15 m
          </span>
        </div>

        <div className="px-5 pt-4">
          <div className="flex gap-1.5">
            {STEPS.map((s, i) => (
              <div key={s} className={`h-1.5 flex-1 rounded-full ${i < 4 ? "bg-emerald-600" : "bg-stone-200"}`} />
            ))}
          </div>
          <div className="mt-2 flex justify-between text-[11px] font-body text-stone-500">
            <span>Etapa 4 de 6 · Evaporadores</span>
            <span className="font-mono">-23.5505, -46.6333</span>
          </div>
        </div>

        <div className="p-5 grid grid-cols-[minmax(0,1fr)] sm:grid-cols-5 gap-4">
          <div className="sm:col-span-3 relative rounded-xl overflow-hidden bg-stone-900 aspect-[4/3]">
            <div
              className="absolute inset-0 opacity-40"
              style={{
                backgroundImage:
                  "linear-gradient(rgba(255,255,255,.08) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.08) 1px, transparent 1px)",
                backgroundSize: "28px 28px",
              }}
            />
            <div className="absolute inset-x-8 inset-y-6 rounded-lg bg-gradient-to-b from-sky-200/20 to-stone-700/40 border border-white/10" />
            <div className="absolute left-[18%] top-[22%] w-[52%] h-[46%] border-2 border-emerald-400 rounded-md">
              <span className="absolute -top-6 left-0 text-[10px] font-bold text-emerald-300 bg-stone-950/80 px-1.5 py-0.5 rounded font-body">
                Evaporador 02 · sem gelo
              </span>
            </div>
            <div className="absolute inset-x-3 bottom-3 rounded-lg bg-stone-950/85 backdrop-blur border border-stone-700 px-3 py-2 flex items-center gap-2">
              <ScanSearch className="h-4 w-4 text-emerald-400 shrink-0" />
              <div className="min-w-0">
                <div className="text-[11px] font-bold text-white font-body">Validação IA · Válido (98%)</div>
                <div className="text-[10px] text-stone-400 font-body truncate">Gelo ausente nos evaporadores · foto ao vivo, galeria bloqueada</div>
              </div>
            </div>
          </div>

          <div className="sm:col-span-2 flex flex-col gap-3">
            <div className="rounded-xl border border-stone-200 p-3">
              <div className="text-[10px] uppercase tracking-wider text-stone-500 font-body font-bold">Temperatura</div>
              <div className="mt-1 font-display text-3xl font-black text-stone-950">-18,4 °C</div>
              <div className="mt-1 flex items-center gap-1.5 text-[11px] text-emerald-800 font-body font-semibold">
                <CheckCircle2 className="h-3.5 w-3.5" /> Faixa -22 a -15 °C
              </div>
            </div>
            <div className="rounded-xl border border-stone-200 p-3 flex-1">
              <div className="text-[10px] uppercase tracking-wider text-stone-500 font-body font-bold">Registro</div>
              <div className="mt-1 font-body text-sm text-stone-800">Marcos Silveira</div>
              <div className="font-mono text-[11px] text-stone-500">06:45 · Cozinha Matriz</div>
              <div className="mt-2 inline-flex items-center gap-1 text-[10px] font-bold text-emerald-800 bg-emerald-50 border border-emerald-200 rounded px-1.5 py-0.5 font-body">
                <Camera className="h-3 w-3" /> Foto obrigatória
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="absolute -bottom-8 right-2 sm:-right-6 max-w-[300px] rounded-2xl rounded-tr-sm bg-[#dcf8c6] text-stone-900 shadow-xl border border-emerald-200 px-4 py-3"
        data-testid="checklist-whatsapp-bubble"
      >
        <div className="flex items-center gap-1.5 font-body text-[11px] font-bold text-emerald-900">
          <MessageCircle className="h-3.5 w-3.5" /> Alerta Ultra · Gerência
        </div>
        <p className="font-body text-xs leading-snug mt-0.5">
          <b>Cozinha Matriz:</b> turno da manhã concluído 100% conforme por Marcos Silveira às 06:45. Relatório PDF anexo.
        </p>
        <div className="mt-1 flex justify-end items-center gap-1 text-[10px] text-stone-500 font-body">
          06:46 <CheckCheck className="h-3.5 w-3.5 text-sky-500" />
        </div>
      </div>
    </div>
  );
}

export default function PillarChecklists() {
  return (
    <section id="checklists" data-testid="landing-pillar-checklists" className="bg-white border-y border-stone-200 py-24 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-[minmax(0,1fr)] lg:grid-cols-12 gap-12 lg:gap-10 items-center">
        <Reveal className="lg:col-span-5">
          <SectionTag>Pilar 01 · Gestão Operacional</SectionTag>
          <SectionTitle>Checklists planejados com dados, não com achismo.</SectionTitle>
          <p className="mt-5 font-body text-base md:text-lg text-stone-600 leading-relaxed">
            Fim do preenchimento no papel no fim do dia. Cada item exige prova real: foto validada por IA, geolocalização conferida e alerta instantâneo no WhatsApp da gerência.
          </p>
          <ul className="mt-8 space-y-5">
            <Bullet icon={Camera} title="Foto obrigatória com validação por IA" desc="Reconhece se o óleo está escuro ou se a bancada está limpa antes de aceitar o registro." />
            <Bullet icon={MapPin} title="Trava de GPS e geofencing" desc="Garante que o colaborador está fisicamente dentro da cozinha no momento da execução." />
            <Bullet icon={MessageCircle} title="Notificações no WhatsApp oficial" desc="Relatório do turno, temperatura fora da faixa e ocorrências críticas direto no celular do gestor." />
            <Bullet icon={Sparkles} title="Gerador de checklist por IA" desc="Digite “fechamento de sushi bar” e o Ultra monta o template com limites sanitários completos." />
          </ul>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-7 pb-10">
          <ChecklistMockup />
        </Reveal>
      </div>
    </section>
  );
}
